import React, { Component } from 'react';
import Selector from './Selector'
import './ChordPicker.css'

class ChordPicker extends Component {
  
  constructor(props) {
    super(props)
    this.state = {rootId: 0, chordId: 0}
    this.onChordChanged = this.onChordChanged.bind(this)
    this.onRootSelection = this.onRootSelection.bind(this)
    this.onChordSelection = this.onChordSelection.bind(this)
    this.onRootDropdownSelection = this.onRootDropdownSelection.bind(this)
    this.onChordDropdownSelection = this.onChordDropdownSelection.bind(this)
  }

  onChordChanged(rootId, chordId) {
    const chordChangeHandler = this.props.chordChangeHandler
    chordChangeHandler(rootId, chordId)
  }

  onRootSelection(value) {
    this.setState({rootId: value})
    this.onChordChanged(value, this.state.chordId)
  }

  onChordSelection(value) {
    this.setState({chordId: value})
    this.onChordChanged(this.state.rootId, value)
  }

  onRootDropdownSelection(event, index, value) {
    this.onRootSelection(value)
  }

  onChordDropdownSelection(event, index, value) {
    this.onChordSelection(value)
  }

  makeButtonSelector(roots, chords, selectedChord) {
    const rootItems = roots.map((note) => ({value: note.id, title: note.names[0]}))
    const chordItems = chords.map((chord) => ({value: chord.id, title: chord.abbr[0]}))

    return (
      <div className="chord-picker">
        <Selector 
          items={rootItems}
          onSelection={this.onRootSelection}
          class="root-selector"
          selectedValue={selectedChord.root.id}
          title="Select Root"
        />
        <Selector
          items={chordItems}
          onSelection={this.onChordSelection}
          class="chord-selector"
          selectedValue={selectedChord.id}
          title="Select Chord"
        />
      </div>
    );
  }

  render() {
    const selectedChord = this.props.selectedChord
    const roots = this.props.notes
    const chords = this.props.chords

    return (
      <div className="chord-picker-root">
          {this.makeButtonSelector(roots, chords, selectedChord)}
      </div>
    )
  }
}

export default ChordPicker;



// WEBPACK FOOTER //
// ./src/ChordPicker.js